































































import {Component, Vue} from "vue-property-decorator";
import * as storeHelper from '@/store/store.helper';
import {DocumentsModule, UsersModule} from '@/store/store.helper';
import {NAVBAR_SIDE_ICON, NavBarInterface} from "@/store/types";
import * as enums from '@/types/enums';
import {MiniUserInterface} from "@/types/interfaces";
import quillEditor from '@/components/quill.editor/quill.editor.vue';
import coloredSvg from '@/components/colored.svg/colored.svg.vue';
import Counters from '@/components/counters/Counters.vue';

Component.registerHooks(['beforeRouteEnter']);

@Component({
  components: {
    quillEditor,
    'colored-svg': coloredSvg,
    Counters,
  }
})

export default class EnteringPage extends Vue {
  @DocumentsModule.DocumentsGetter private documentWelcome;
  @DocumentsModule.DocumentsGetter private documentEditors;

  @DocumentsModule.DocumentsAction private updateDocument;
  @UsersModule.UsersGetter private isSignedIn;
  @UsersModule.UsersGetter private user: MiniUserInterface;

  @storeHelper.RouterModule.RouterGetter
  private getPath: (object) => string;
  @storeHelper.RouterModule.RouterAction
  private push;
  @storeHelper.DisplayModule.DisplayMutation private setNavBar;
  @storeHelper.DisplayModule.DisplayGetter private getColor;
  @storeHelper.ArgumentsModule.ArgumentsGetter
  private argumentsSize: () => number;
  @storeHelper.CommentsModule.CommentsGetter
  private commentsSize: () => number;
  @storeHelper.RouterModule.RouterGetter
  private currentRoute;
  @storeHelper.SectionsModule.SectionsAction
  private getSizeByStatus: (number) => number;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentAllowedUsers;
  @storeHelper.UsersModule.UsersGetter
  private participantsSize: number;

  private isEdit: boolean = false;
  private newContent: string = '';
  private inTheVoteSize: number = 0;
  public counterParticipants: number = 0;
  private approvedSize: number = 0;

  public beforeRouteEnter(to, from, next) {
    /**
     * if the path is empty -> push to path with the full path
     */
    if (to.path === '/') {
      next((vm) =>
          vm.push({
            path: vm.getPath({name: enums.ROUTE_NAME.welcome, params: {}}),
          }),
      );
    } else {
      next();
    }
  }

  /**
   * @return void
   */
  private goToChoose(): void {
    this.$router.push({name: enums.ROUTE_NAME.chooseTopics})
  }

  private goToDraft(): void {
    this.$router.push({name: enums.ROUTE_NAME.draft});
  }

  get isUserEditor() {
    return this.isSignedIn && this.documentEditors ?
        this.user.notifications && this.documentEditors.includes(this.user.notifications.mailAddress) : false;
  }

  private edit() {
    this.newContent = this.documentWelcome.welcomeContent;
    this.isEdit = true;
  }

  private async save() {
    await this.updateDocument({
      updateObject: {
        documentWelcome: {
          welcomeContent: this.newContent,
          welcomeTitle: this.documentWelcome.welcomeTitle
        }
      }
    });
    this.isEdit = false;
  }

  private async mounted() {
    const navBarPref: NavBarInterface = {
      title: this.documentWelcome.welcomeTitle,
      icon: NAVBAR_SIDE_ICON.menu,
      color: this.getColor(enums.SECTION_STATUS.inTheVote),
    };
    this.setNavBar(navBarPref);
  }

  private contentChange({html}) {
    this.newContent = html;
  }
}
